import api from '../../api/authentication'

export function show ({ dispatch }) {
  dispatch('SHOW_AUTH')
}

export function login ({ dispatch, state }, username, password) {
  dispatch('LOGIN_REQUEST')
  return api.login(
    username,
    password,
    (data) => {
      data.status
        ? dispatch('LOGIN_SUCCESS', data.user)
        : dispatch('LOGIN_FAILURE', data.message)
    },
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}

export function logout ({ dispatch }) {
  return api.logout(
    () => {
      dispatch('LOGOUT')
    },
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}



/** WEBPACK FOOTER **
 ** ./src/vuex/actions/authentication.js
 **/